import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";
import { authSlice } from "./createAuthSlice";
import { commonSlice } from "./createCommonSlice";
import { navSlice } from "./createNavSlice";

export const useStore = create(
	persist(
		(set) => ({
			...authSlice(set),
			...commonSlice(set),
			...navSlice(set),
		}),
		{
			name: "opa-storage",
			storage: createJSONStorage(() => sessionStorage),
		}
	)
);

// export const useStore = create((set) => ({
// 	...authSlice(set),
// 	...commonSlice(set),
// }));
